// Client-side flash toasts. They reuse the server-rendered flash container
// (`#flash`, which carries `data-controller="toast"`): appending an element with
// `data-toast-target="toast"` is enough for toast_controller's
// `toastTargetConnected` to show it and clean it up on hide. Keep the markup in
// step with app/views/controllers/application/_flash_message.html.haml.

export function flashDanger(message) {
  const container = document.getElementById("flash");
  if (!container) return;

  const toast = document.createElement("div");
  toast.className = "toast align-items-center border-0 text-bg-danger";
  toast.setAttribute("role", "alert");
  toast.setAttribute("aria-atomic", "true");
  toast.setAttribute("aria-live", "assertive");
  toast.dataset.toastTarget = "toast";

  const body = document.createElement("div");
  body.className = "toast-body";
  body.textContent = message;

  const close = document.createElement("button");
  close.type = "button";
  close.className = "btn-close me-2 m-auto";
  close.setAttribute("aria-label", "Close");
  close.dataset.action = "click->toast#close";

  const row = document.createElement("div");
  row.className = "d-flex";
  row.append(body, close);
  toast.append(row);

  container.append(toast);
}

// If `file` is larger than the cap the server rendered onto `element`
// (`data-max-upload-bytes`), return the localised rejection message
// (`data-too-large-message`); otherwise return null. Shared by every uploader
// Stimulus controller so the check reads the same everywhere.
export function uploadSizeError(file, element) {
  const max = Number(element.dataset.maxUploadBytes);
  if (!max || file.size <= max) return null;

  return element.dataset.tooLargeMessage;
}
